module.exports = __webpack_public_path__ + "img/very-bad.ddbf82ea.svg";